import { Block, component } from '../../../scripts/core/Component'

@component('input')
class Input extends Block {
  constructor (context) {
    super(context)
    
    this.inputElement = this.element('el').first()
  }
  
  validate() {
    if(this.inputElement.el.validity.valid) {
      return {
        result: true
      }
    }

    this.inputElement.el.checkValidity()
    
    return {
      result: false,
      message: ''
    }
  }
}

export {
  Input
}


// WEBPACK FOOTER //
// ./components/ui/input/index.js